export const CLEAR_USERS_BROWSERS_REQUEST = 'CLEAR_USERS_BROWSERS_REQUEST';
export const CLEAR_USERS_BROWSERS_SUCCESS = 'CLEAR_USERS_BROWSERS_SUCCESS';
export const CLEAR_USERS_BROWSERS_FAILURE = 'CLEAR_USERS_BROWSERS_FAILURE';

export const FETCH_TRUSTED_BROWSERS_REQUEST = 'FETCH_TRUSTED_BROWSERS_REQUEST';
export const FETCH_TRUSTED_BROWSERS_SUCCESS = 'FETCH_TRUSTED_BROWSERS_SUCCESS';
export const FETCH_TRUSTED_BROWSERS_FAILED = 'FETCH_TRUSTED_BROWSERS_FAILED';
